<template>
<!-- 예스코인 환불 확인 팝업 -->
    <div role="dialog" class="mobile-toast-popup" :class="{active : visibleRefundConfirmToastPopup}">
        <div class="opacity-bg" @click.prevent="closeToastPopup('mobileClose')"></div>
        
        <!-- 모바일 태블릿은 토스트팝업, PC는 레이어팝업 형태 -->
        <div class="toast-layout pc-popup">

            <div class="popup-compo-body position-relative">
                <div class="result-success">
                    <IconDollar></IconDollar>
                    <p>환불 신청하시겠습니까?</p>
                    <p class="result-success__txt"><strong>환불 신청 금액과 계좌정보, <br>수수료</strong>와 함께 환불 신청을 진행합니다.</p>
                </div>

                <!-- 완료페이지와 중복 영역에 고민 중 -->
                <table class="key-value value-right">
                    <tr>
                        <th>환불 신청 금액</th>
                        <td>{{requestedRefundYescoin}}</td>
                    </tr>
                    <tr>
                        <th>계좌정보</th>
                        <td>{{refundAccountDatas.bankBrand}} {{refundAccountDatas.bankAccountNum}} {{refundAccountDatas.accountHolder}}</td>
                    </tr>
                </table>
                <!-- 수수료 안내 문구 박스 -->
                <template v-if="activeInfoFee">
                    <div class="info-box info-box__fee position-absolute" @click.self="closeInfoFee" :class="{'active' : activeInfoFee}">
                        <IconClose @click.native="closeInfoFee" aria-label="닫기"></IconClose>
                        <ul class="info">
                            <li class="info-li"><span>충전 시 사용한 결제 수단과 결제 취소 가능 여부에 따라 환불 수수료가 발생할 수 있습니다.<br>
                            예) 신용카드 결제 후 결제 취소 불가로 계좌 환불 처리되는 경우 환불 수수료 발생</span></li>
                        </ul>
                    </div>
                </template>
                <!-- // 완료페이지와 중복 영역에 고민 중 -->
                
                <div class="compo-info-box mt-0">
                    - 예금주와 회원정보의 사업자 상호명 또는 대표자명이 일치하지 않는 경우 환불이 불가할 수 있습니다.<br>
                    - 예스코인 결제 취소가 가능한 경우 카드결제 취소 처리됩니다.<br>
                    - 계좌 환불 시 5%의 출금 수수료가 발생할 수 있습니다.<br>
                    - 환불 신청 후 계좌입금 완료 시까지 7~14일이 소요됩니다. 
                </div>

                <div class="btns">
                    <button type="button" @click="closeToastPopup" class="btn-l btn-w-l">취소</button>
                    <button type="button" @click="dispatchRegistYescoinRefund" class="btn-l btn-w">환불 신청</button>
                </div>
            </div>

            <!-- PC 팝업 닫기 아이콘 -->
            <button @click.prevent="closeToastPopup('desktopClose')" class="position-absolute i-x tablet-none" aria-label="환불 신청 닫기">
                <IconClose />
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    components: {
        IconClose: () => import('@/components/svg-icon/IconClose.vue'),       // 닫기 아이콘
        IconDollar: () => import('@/components/svg-icon/IconDollar.vue'),     // 달러 아이콘
        // IconInfo: () => import('@/components/svg-icon/IconInfo.vue'),         // 인포메이션 아이콘
    },

    props: {
        refundAccountDatas: {
            bankCd: '',                 // 저장된 은행코드
            bankBrand: '',              // 저장된 은행명
            bankAccountNum: '',         // 저장된 계좌번호
            accountHolder: '',          // 예금주
        },
        estimatedCoinBalance: {         // 환불 후 예상 코인 잔액
            type: String
        },
        requestedRefundYescoin: {       // 환불 요청 금액
            type: String
        }
    },

    data() {
        return {
            activeInfoFee: false,                           // 수수료 면제 안내 박스 노출 여부
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexSendId: state => state.vuexSendId,
            visibleRefundConfirmToastPopup: state => state.modalStore.modalsObj.visibleRefundConfirmToastPopup
        }),
	},

    mounted() {
        this.controlBodyScroll();
    },

    watch:{
        visibleRefundConfirmToastPopup(){
            this.controlBodyScroll();
        }
    },

    methods: {
        // 토스트팝업 외부영역 클릭 시 모바일 토스트 팝업 닫기
        closeToastPopup(){
            this.$store.commit('modalStore/setVisibleRefundConfirmToastPopup', false);
        },

        // 이중스크롤 제어
        controlBodyScroll(){
            if(this.visibleRefundConfirmToastPopup){
                this.$store.commit('modalStore/bodyScrollHandler');
            }else{
                this.$store.commit('modalStore/restoreBodyScroll');
            }
        },
        
        // 환불 신청 완료 페이지로 전달
        async dispatchRegistYescoinRefund() {
            try {
                const data = {
                    bankCode: this.refundAccountDatas.bankCd,
                    bankNm : this.refundAccountDatas.bankBrand,
                    account: this.refundAccountDatas.bankAccountNum,
                    accountNm: this.refundAccountDatas.accountHolder,
                }
                const response = await this.$store.dispatch('refundStore/actionsRegistYescoinRefund', data);
                this.closeToastPopup();
                this.$router.push({ name: 'refund-success', params: {yescoinRefundId: response.data.yescoinRefundId}})
            } catch (err) {
                alert(err.response.data.message);
                return;
            }
        },

        // 수수료 면제 안내 아이콘 클릭시 노출되는 박스
        showInfoFee(){
            this.activeInfoFee = true;
        },

        // 인포박스 닫기
        closeInfoFee(){
            this.activeInfoFee = false;
        },
    },
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/orderhistory.scss';
</style>